import SelectFlowByBranch from './SelectFlowByBranch.vue'
import UpdateNotiLinaOA from './UpdateNotiLinaOA.vue'

export default {
  SelectFlowByBranch,
  UpdateNotiLinaOA
}



// WEBPACK FOOTER //
// ./src/components/Kiosk/index.js